import { Avatar, Box, Typography } from '@mui/material';
import TimeAgo from 'javascript-time-ago';
import { useTranslation } from 'react-i18next';
import RecordVoiceOverIcon from '@mui/icons-material/RecordVoiceOver';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import clsx from 'clsx';
import { NotificationFieldsFragment } from '../../../../../../../../generated/core-api/graphql-react-query';

export default function AvailableCommandNotificationBox(props: { notification: NotificationFieldsFragment }) {
  const { notification } = props;
  const { t, i18n } = useTranslation('widgets');
  const timeAgo = new TimeAgo(i18n.language);
  return (
    <>
      <Avatar className="user">
        <RecordVoiceOverIcon />
      </Avatar>
      <Box className="message userRoleChanged">
        <Typography variant="subtitle1">
          <strong>{notification.event.author?.displayName}</strong>
          {t('notifications.command.available')}
          <span className={clsx('subject', { deleted: notification.event.projectCommand?.deletedAt })}>{notification.event.command?.text}</span>
        </Typography>
        <Typography variant="body1" component="div">
          <div className={clsx('project', { deleted: notification.event.project?.archived })}>{notification.event.project?.name}</div>
          {notification.event.card && (
            <>
              <ChevronRightIcon />
              <div className={clsx('project', { deleted: notification.event.card?.deletedAt })}>{notification.event.card.title}</div>
            </>
          )}
        </Typography>
        <Typography variant="subtitle2">
          {timeAgo.format(new Date(notification.date))}
        </Typography>
        <Typography variant="subtitle2">
          {notification.event.projectCommand?.deletedAt && `${t('notifications.deleted')} ${timeAgo.format(new Date(notification.event.projectCommand?.deletedAt))}`}
        </Typography>
      </Box>
    </>
  );
}
